export default __webpack_public_path__ + "static/media/480_store05-nl-web.70779008.png";